// extracted by mini-css-extract-plugin
export default {"imageContainer":"ImageFlip_imageContainer__uxIpE","mainImage":"ImageFlip_mainImage__neu6L","icon":"ImageFlip_icon__oFMKm","motion":"ImageFlip_motion__sRu7Y"};